import { Box, Button, Flex } from '@mafc/trolly';
import React from 'react';

interface IProps {
  expressBtn: any;
  showPrimaryButton: boolean;
  isNewJourney: boolean;
  callback: () => void;
  isCart: boolean;
  btnHeight: number;
  disabled: boolean;
  ctaText: string;
}

const PlaceOrder = ({
  expressBtn,
  showPrimaryButton,
  isNewJourney,
  callback,
  isCart,
  btnHeight,
  disabled,
  ctaText,
}: IProps): JSX.Element => {
  return (
    <>
      {/** Express Cart Checkout Button */}
      {!!expressBtn && expressBtn}

      {/** Primary Cart Checkout Button */}
      {showPrimaryButton && (
        <Flex width={isNewJourney ? 1 / 2 : 1} alignItems="center">
          <Button
            onClick={callback}
            testid={'proceed-to-checkout-button'}
            flex="auto"
            p={2}
            ml={isCart ? 1 : 0}
            height={btnHeight}
            disabledNew={disabled}
            fontWeight={5}
            fontSize={2}
            width={`${isNewJourney ? '50%' : 'auto'}`}
            preventTextTransform={isNewJourney}
            variant={isCart && !isNewJourney ? 'primary' : 'secondary'}
            size="CUSTOM"
            borderRadius={3}
          >
            <Box as="span">{ctaText}</Box>
          </Button>
        </Flex>
      )}
    </>
  );
};

export default PlaceOrder;
